import { exposeToGlobalScope } from '../utils/utilsGlobal';
import Logger from './Logger';
import PWA, * as PWAEventTypes from './PWA';
import UserWatcher, * as UserWatcherEventTypes from './UserWatcher';
import SoundNotifications, * as SoundNotificationsEventTypes from './SoundNotifications';
import OpenedTabsWatcher, * as OpenedTabsWatcherEventTypes from './OpenedTabsWatcher';
import WorkHoursScheduler, * as WorkHoursSchedulerEventTypes from './WorkHoursScheduler';
import PushNotifications, * as PushNotificationsEventTypes from './PushNotifications';
import MessageSubscription, * as MessageSubscriptionEventTypes from './MessageSubscription';
import TotalUnreadCounter, * as TotalUnreadCounterEventTypes from './TotalUnreadCounter';
import * as UpdateMessageSubscriptionEventTypes from './UpdateMessageSubscription';
import * as TypingUsersSubscriptionEventTypes from './TypingUsersSubscription';
import GraphQLClient, { GraphQLClientSocket } from './GraphQLClient';
import RoomListSubscription from './RoomListSubscription';


const logger = new Logger({
  sentry: process.env.NODE_ENV === 'production',
  loggly: false, // TODO: fix & enable (?) Loggly
});

const services = {
  graphQLClient: new GraphQLClient(),
  graphQLClientSocket: new GraphQLClientSocket(),
  logger,
  pwa: new PWA(),
  soundNotifications: new SoundNotifications(),
  openedTabsWatcher: new OpenedTabsWatcher(),
  workHoursScheduler: new WorkHoursScheduler(),
  pushNotifications: new PushNotifications(),
  messageSubscription: new MessageSubscription(),
  totalUnreadCounter: new TotalUnreadCounter(),
  roomListSubscription: new RoomListSubscription(),
  userWatcher: new UserWatcher(),
};

export default services;
export const events = {
  ...PWAEventTypes,
  ...SoundNotificationsEventTypes,
  ...OpenedTabsWatcherEventTypes,
  ...WorkHoursSchedulerEventTypes,
  ...PushNotificationsEventTypes,
  ...MessageSubscriptionEventTypes,
  ...TotalUnreadCounterEventTypes,
  ...UpdateMessageSubscriptionEventTypes,
  ...TypingUsersSubscriptionEventTypes,
  ...UserWatcherEventTypes,
};
export const logInfo = logger.logInfo;
export const logError = logger.logError;
export const logEvent = logger.logEvent;

exposeToGlobalScope('services', services);
exposeToGlobalScope('events', events);
